var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showDetail)?_c('UbicationTechAssistanceWrapper'):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }